module.exports = "<ui-switch\r\n    [size]=\"size\"\r\n    [color]='publishBgColor'\r\n    switchColor='#FFFFFF'\r\n    [defaultBgColor]='unpublishBgColor'\r\n    defaultBoColor='none'\r\n    checkedLabel='PUBLISHED'\r\n    uncheckedLabel='UNPUBLISHED'\r\n    [(ngModel)]=\"model\"\r\n    (ngModelChange)=\"onModelChange($event)\"\r\n></ui-switch>"


//////////////////
// WEBPACK FOOTER
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/publish-toggle-switch/publish-toggle-switch.component.html
// module id = ../../../../../src/app/shared/publish-toggle-switch/publish-toggle-switch.component.html
// module chunks = main